// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3LbsL","modalFooterButton":"ModalNotes_modalFooterButton__1Ksv0"};